import { useState } from "react";
import { FaTimes } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import "bulma/css/bulma.css";
import "../Styled.css"
import LoaderHome from "../../Loader/LoaderHome"
import { ReactComponent as PrayingIcon } from "../../../assets/reminder_card/praying.svg";
import { ReactComponent as HealtyIcon } from "../../../assets/reminder_card/healty.svg";
import { ReactComponent as MedicalIcon } from "../../../assets/reminder_card/medical.svg";
import { ReactComponent as WashHandsIcon } from "../../../assets/reminder_card/wash.svg";
import { ReactComponent as ToolsIcon } from "../../../assets/reminder_card/tools.svg";
import { ReactComponent as DocumentsIcon } from "../../../assets/reminder_card/document.svg";
import { ReactComponent as ConfirmIcon } from "../../../assets/reminder_card/confirmation.svg";
import { Card } from "react-bootstrap";

export default function ModalRoleAdd(props) {
  const [propsData, setProopsData] = useState()
  const [loading, setLoading] = useState(false);


  const iconWrapperStyle = {
    height: "180px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const iconStyle = {
    height: "100%",
    width: "auto",
    maxWidth: "100%",
    color: "#29B8FF"
  }

  return (
    <Modal {...props} onHide={props.onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered style={{ fontFamily: "sans-serif", border: "none" }}>
      {loading && <LoaderHome />}

      <div
        style={{
          width: "100%",
          display: "flex",
          padding: "10px 0px",
          backgroundColor: "#29B8FF",
          position: "sticky",
          top: 0,
          zIndex: 1050
        }}
      >
        <div
          style={{
            flex: "92%",
            fontSize: "20px",
            display: "flex",
            alignItems: "center",
            paddingLeft: "10px",
            color: "white",
            fontWeight: "600"
          }}
        >
          Kartu Pengingat Sebelum Memulai Kerja
        </div>

        <div
          style={{
            flex: "8%",
            fontSize: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white"
          }}
        >
          <FaTimes
            onClick={() => setProopsData(props.onHide)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>

      <Modal.Body style={{ backgroundColor: "", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px", border: "none" }}>
        <Card className="mb-3 shadow-md border-0">
          <Card.Body>
            <div className="row align-items-center">
              <div className="col-md-4"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  padding: "16px",
                  backgroundColor: "#fff"
                }}>
                <div style={iconWrapperStyle}>
                  <PrayingIcon style={iconStyle} />
                </div>
              </div>
              <div className="col-md-7 d-flex align-items-center">
                <div className="container text-center" style={{
                  fontSize: "15px",
                  fontWeight: "800",
                  lineHeight: "1.6",
                  color: "#333"
                }}>
                  1. Pastikan berdoa sebelum mulai bekerja
                </div>
              </div>
              <div className="col-md-1 d-flex align-items-center"></div>
            </div>
          </Card.Body>
        </Card>

        <Card className="mb-3 shadow-md border-0">
          <Card.Body>
            <div className="row align-items-center">
              <div className="col-md-1 d-flex align-items-center">
              </div>
              <div className="col-md-7 d-flex align-items-center">
                <div className="container text-center" style={{
                  fontSize: "15px",
                  fontWeight: "800",
                  lineHeight: "1.6",
                  color: "#333"
                }}>
                  2. Periksa kondisi fisik & mental
                </div>
              </div>

              <div className="col-md-4"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  padding: "16px",
                  backgroundColor: "#fff"
                }}>
                <div style={iconWrapperStyle}>
                  <HealtyIcon style={iconStyle} />
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>

        <Card className="mb-3 shadow-md border-0">
          <Card.Body>
            <div className="row align-items-center">
              <div className="col-md-4"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  padding: "16px",
                  backgroundColor: "#fff"
                }}>
                <div style={iconWrapperStyle}>
                  <MedicalIcon style={iconStyle} />
                </div>
              </div>
              <div className="col-md-7 d-flex align-items-center" style={{
                fontSize: "15px",
                fontWeight: "800",
                lineHeight: "1.6",
                color: "#333"
              }}>
                <div className="container text-center">
                  3. Gunakan APD lengkap
                </div>
              </div>
              <div className="col-md-1 d-flex align-items-center">
              </div>
            </div>
          </Card.Body>
        </Card>

        <Card className="mb-3 shadow-md border-0">
          <Card.Body>
            <div className="row align-items-center">
              <div className="col-md-8">
                <div className="container text-center" style={{
                  fontSize: "15px",
                  fontWeight: "800",
                  lineHeight: "1.6",
                  color: "#333"
                }}>
                  4. Cuci tangan sesuaiprotokol 6 langkah
                </div>
              </div>
              <div
                className="col-md-4 d-flex align-items-center"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  padding: "16px",
                  backgroundColor: "#fff"
                }}
              >
                <div style={iconWrapperStyle}>
                  <WashHandsIcon style={iconStyle} />
                </div>
              </div>

            </div>
          </Card.Body>
        </Card>

        <Card className="mb-3 shadow-md border-0">
          <Card.Body>
            <div className="row align-items-center">
              <div className="col-md-4"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  padding: "16px",
                  backgroundColor: "#fff"
                }}>
                <div style={iconWrapperStyle}>
                  <ToolsIcon style={iconStyle} />
                </div>
              </div>
              <div className="col-md-7 d-flex align-items-center">
                <div className="container text-center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "800",
                    lineHeight: "1.6",
                    color: "#333"
                  }}>
                  5. Pastikan alat steril & siap pakai
                </div>
              </div>

            </div>
          </Card.Body>
        </Card>

        <Card className="mb-3 shadow-md border-0">
          <Card.Body>
            <div className="row align-items-center">
              <div className="col-md-8">
                <div className="container text-center" style={{
                  fontSize: "15px",
                  fontWeight: "800",
                  lineHeight: "1.6",
                  color: "#333"
                }}>
                  6.  Periksa ketepatan identitas & rekam medis pasien
                </div>
              </div>
              <div
                className="col-md-4 d-flex align-items-center"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  padding: "16px",
                  backgroundColor: "#fff"
                }}
              >
                <div style={iconWrapperStyle}>
                  <DocumentsIcon style={iconStyle} />
                </div>
              </div>

            </div>
          </Card.Body>
        </Card>

        <Card className="mb-3 shadow-md border-0">
          <Card.Body>
            <div className="row align-items-center">
              <div className="col-md-4"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  padding: "16px",
                  backgroundColor: "#fff"
                }}>
                <div style={iconWrapperStyle}>
                  <ConfirmIcon style={iconStyle} />
                </div>
              </div>
              <div className="col-md-7 d-flex align-items-center">
                <div className="container text-center"
                  style={{
                    fontSize: "15px",
                    fontWeight: "800",
                    lineHeight: "1.6",
                    color: "#333"
                  }}>
                  7. Konfirmasi informasi dan tindakan yang akan dilakukan
                </div>
              </div>

            </div>
          </Card.Body>
        </Card>

      </Modal.Body>
    </Modal>
  );
}
